export default "__VITE_ASSET__C6lm95mE__"